import axios from 'axios'

export default {
    getList(practiceId, { query, fields, userRoleId, practiceMembershipStatus, limit, offset, sort } = {}) {
        if (query && query.length < 2) {
            return Promise.resolve([])
        }

        const _fields = (
            fields || [
                'id',
                'firstName',
                'middleName',
                'lastName',
                'designation',
                'email',
                'userRole(id,name)',
                'professionalRating',
                'rating',
                'newReferrals',
                'newReferralsCount',
                'referralsMadeCount',
                'referralsReceivedCount',
                'isSignupFinished',
                'isProfileComplete',
                'isPasswordSet',
                'specialities(id,speciality(id,name),subSpeciality(id,name),practicingSince)',
                'isAvailabilitySet',
                'npiNumber',
                'boardCertified',
                'disciplinaryActions',
                'malpracticeClaimsLost',
                'medicalLicenses(id,licenseNumber,year,state)',
                'practiceMembershipStatus',
                'connectionCount',
                'practice(id,name,practiceType,locations(id,name,address,city,state,zip,isAvailabilitySet),insurancePlans(id,name,insurancePlanGroup(id,name)))',
                'isMasterUser',
                'canModifyPracticeMemberAvailability',
                'medicalSchools(id,name,city,state)',
                'residencies(id,name,city,state)',
                'affiliatedHospitals(id,name,city,state)',
                'fellowships(id,name,city,state)',
                'shortBiography',
                'languages',
                'gender',
                'phone',
                'avatar(thumb-360,source)',
                'physicianGroupId',
                'physicianGroup(id,name)',
                'notificationCount',
                'isAgreedToSms',
                'mobilePhone',
            ]
        ).join(',')
        return axios.get(`/practices/${practiceId}/members`, {
            params: { _fields, query, userRoleId, practiceMembershipStatus, limit, offset, sort },
        })
    },
}
